var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0266 12.4C15.1417 11.9544 15.5962 11.6864 16.0418 11.8015C16.9357 12.0323 17.7277 12.5534 18.2933 13.283C18.8589 14.0127 19.1662 14.9095 19.1668 15.8327V17.5C19.1668 17.9602 18.7938 18.3333 18.3335 18.3333C17.8733 18.3333 17.5002 17.9602 17.5002 17.5V15.834C17.4997 15.2801 17.3154 14.7419 16.976 14.3042C16.6367 13.8664 16.1615 13.5537 15.6252 13.4152C15.1796 13.3001 14.9116 12.8456 15.0266 12.4Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6929 2.40164C11.807 1.95578 12.261 1.68689 12.7069 1.80104C13.6031 2.03052 14.3975 2.55177 14.9648 3.28262C15.5321 4.01346 15.84 4.91232 15.84 5.8375C15.84 6.76268 15.5321 7.66154 14.9648 8.39239C14.3975 9.12323 13.6031 9.64448 12.7069 9.87396C12.261 9.98812 11.807 9.71922 11.6929 9.27337C11.5787 8.82751 11.8476 8.37353 12.2935 8.25938C12.8312 8.12169 13.3079 7.80894 13.6483 7.37043C13.9886 6.93193 14.1734 6.39261 14.1734 5.8375C14.1734 5.2824 13.9886 4.74308 13.6483 4.30457C13.3079 3.86607 12.8312 3.55332 12.2935 3.41563C11.8476 3.30147 11.5787 2.84749 11.6929 2.40164Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49998 3.33333C6.11927 3.33333 4.99998 4.45262 4.99998 5.83333C4.99998 7.21405 6.11927 8.33333 7.49998 8.33333C8.88069 8.33333 9.99998 7.21405 9.99998 5.83333C9.99998 4.45262 8.88069 3.33333 7.49998 3.33333ZM3.33331 5.83333C3.33331 3.53215 5.19879 1.66667 7.49998 1.66667C9.80117 1.66667 11.6666 3.53215 11.6666 5.83333C11.6666 8.13452 9.80117 10 7.49998 10C5.19879 10 3.33331 8.13452 3.33331 5.83333Z",
    fill: "#4F5E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99998 13.3333C3.61927 13.3333 2.49998 14.4526 2.49998 15.8333V17.5C2.49998 17.9602 2.12688 18.3333 1.66665 18.3333C1.20641 18.3333 0.833313 17.9602 0.833313 17.5V15.8333C0.833313 13.5321 2.69879 11.6667 4.99998 11.6667H9.99998C12.3012 11.6667 14.1666 13.5321 14.1666 15.8333V17.5C14.1666 17.9602 13.7936 18.3333 13.3333 18.3333C12.8731 18.3333 12.5 17.9602 12.5 17.5V15.8333C12.5 14.4526 11.3807 13.3333 9.99998 13.3333H4.99998Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIcon);
export default __webpack_public_path__ + "static/media/staff-icon.bf0fd92ec02d020d84e4d33ceaad05b3.svg";
export { ForwardRef as ReactComponent };